import { getAuthedPathForDesktop, setDesktopSessionId } from 'shared/foreground/auth.desktop';
import getServerBaseUrl from 'shared/utils/getServerBaseUrl.platform';

export async function handleDesktopAuthCallback() {
  if (location.pathname !== '/--/doneauth') {
    return;
  }
  const searchParams = new URLSearchParams(location.search);
  const sessionId = searchParams.get('sessionid');
  if (!sessionId) {
    throw new Error('done auth but no sessionid');
  }
  await setDesktopSessionId(sessionId);
  if (location.pathname === '/--/doneauth') {
    location.pathname = '/';
  }
}

export async function impersonateUserWithEmail(email: string) {
  const authedPath = await getAuthedPathForDesktop();
  const impersonateUrl = `${getServerBaseUrl()}/impersonate/acquire?email=${encodeURIComponent(
    email,
  )}&next=${encodeURIComponent(authedPath)}`;

  window.location.href = impersonateUrl;
}

export async function releaseImpersonatedUser() {
  const authedPath = await getAuthedPathForDesktop();
  const releaseUrl = `${getServerBaseUrl()}/impersonate/release?next=${encodeURIComponent(
    authedPath,
  )}`;

  // Navigate to release URL - the server will handle clearing the impersonation
  // and redirect back with a clean session
  window.location.href = releaseUrl;
}
